import { ZONE_COLORS } from '../constants/adminPageConstants';

/*
 * ТЗ V5 №6: цвет зоны привязан к zone_id, а не к позиции в списке, и один
 * и тот же в админке зон и в наложении на кадры. Слот выбирается хешем
 * zone_id; при совпадении берётся следующий свободный, а зоны обходятся в
 * порядке zone_id — так перестановка списка цвета не меняет, а у зон одной
 * камеры (пока их не больше, чем цветов в палитре) цвета разные.
 */

const hashString = (value) => {
  let hash = 0;
  for (const ch of String(value)) hash = (hash * 31 + ch.codePointAt(0)) >>> 0;
  return hash;
};

export const buildZoneColorMap = (zones = []) => {
  const ids = [...new Set(zones.map((zone) => zone?.zone_id).filter((id) => id != null && id !== ''))]
    .map(String)
    .sort();
  const size = ZONE_COLORS.length;
  const taken = new Set();
  const map = {};
  ids.forEach((id) => {
    let slot = hashString(id) % size;
    if (taken.size < size) {
      while (taken.has(slot)) slot = (slot + 1) % size;
    }
    taken.add(slot);
    map[id] = ZONE_COLORS[slot];
  });
  return map;
};

/** Цвет зоны по карте; зона без zone_id получает цвет по запасному индексу. */
export const zoneColorFrom = (colorMap, zone, fallbackIndex = 0) =>
  (zone?.zone_id != null && colorMap[String(zone.zone_id)])
  || ZONE_COLORS[fallbackIndex % ZONE_COLORS.length];
